import { useEffect, useState } from 'react';

export default function RightSidebar({ visible, showNav, showTopNav, gifs = {} }) {
  const [navHeight, setNavHeight] = useState(0);

  useEffect(() => {
    const measure = () => {
      const nav = document.getElementById('spss-topnav');
      if (nav) setNavHeight(nav.getBoundingClientRect().height);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  const navGap = 10;
  const hasGif = gifs.matrix || gifs.ogir || gifs.sonic;

  return (
    <aside
      className={`fixed right-[18px] top-0 bottom-0 z-40 flex flex-col items-center w-[150px] xl:w-[180px] ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      style={{
        background: 'linear-gradient(180deg, rgba(110,160,220,0.28) 0%, rgba(150,190,235,0.3) 50%, rgba(120,170,225,0.26) 100%)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        border: '1px solid rgba(190,220,255,0.3)',
        borderRight: 'none',
        borderRadius: '14px 0 0 14px',
        boxShadow: '0 0 24px rgba(120,180,255,0.12), inset 0 0 30px rgba(180,215,255,0.08)',
        overflow: 'visible',
        willChange: 'opacity',
        transition: 'opacity 0.4s ease',
      }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          borderRadius: 'inherit',
          background: `repeating-linear-gradient(0deg, transparent, transparent 18px, rgba(100,180,255,0.04) 18px, rgba(100,180,255,0.04) 19px), repeating-linear-gradient(90deg, transparent, transparent 18px, rgba(100,180,255,0.03) 18px, rgba(100,180,255,0.03) 19px)`,
        }}
      />

      <div
        className="flex items-center justify-center"
        style={{
          position: 'absolute',
          right: '-20px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '22px',
          height: '44px',
          borderRadius: '0 6px 6px 0',
          background: 'linear-gradient(180deg, rgba(180,210,255,0.35) 0%, rgba(100,160,230,0.25) 100%)',
          border: '1px solid rgba(180,215,255,0.3)',
          borderLeft: 'none',
          boxShadow: '2px 0 12px rgba(80,160,255,0.15), inset 0 1px 0 rgba(255,255,255,0.2)',
          cursor: 'default',
        }}
      >
        <span style={{ color: 'rgba(220,235,255,0.8)', fontSize: '0.55rem', textShadow: '0 0 6px rgba(150,200,255,0.4)', lineHeight: 1 }}>▶</span>
      </div>

      {hasGif && (
        <div
          className="flex flex-col items-center w-full px-[6px] xl:px-[10px]"
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: showTopNav ? navHeight + navGap : 0,
            bottom: 0,
            zIndex: 1,
            justifyContent: 'center',
            gap: '20px',
            transition: 'top 0.5s ease',
          }}
        >
          {gifs.matrix && (
            <img src={gifs.matrix} alt="Matrix code" className="max-w-[138px] xl:max-w-[156px]" style={{ width: '100%', height: 'auto', borderRadius: '8px', border: '1px solid rgba(0,160,255,0.2)', flexShrink: 0 }} />
          )}
          {gifs.ogir && (
            <img src={gifs.ogir} alt="CRT window" className="max-w-[138px] xl:max-w-[156px]" style={{ width: '100%', height: 'auto', borderRadius: '8px', flexShrink: 0 }} />
          )}
          {gifs.sonic && (
            <img src={gifs.sonic} alt="Sonic" className="max-w-[138px] xl:max-w-[156px]" style={{ width: '100%', height: 'auto', flexShrink: 0 }} />
          )}
        </div>
      )}
    </aside>
  );
}
